<ey-froala-content-wrapper [editorContent]="body"></ey-froala-content-wrapper>
<ul class="ps-0 mt-10">
  <li class="triangle" *ngFor="let lv of listValues"><i class="icon-ico_triangle_right emp-icon"></i>{{ lv }}</li>
</ul>
<span *ngIf="listValues.length < 1">- Not Entered -</span>
